/**
 * Environment detection helpers
 */

// Check if we're in a production environment
export const isProduction = () => {
  return process.env.NODE_ENV === "production";
};

// Check if we're in the US environment based on build-time environment variables
export const isUSEnvironment = () => {
  // For client-side detection
  if (typeof window !== "undefined") {
    // First check hostname for a clear indicator
    const hostname = window.location.hostname;
    if (
      hostname.includes("us.") ||
      hostname.includes("-us") ||
      hostname.includes("us-") ||
      hostname.includes(".us")
    ) {
      return true;
    }

    // Then check for any custom indicators from the build
    if (window.__US_ENVIRONMENT) {
      return true;
    }
  }

  // For server-side detection during build time
  // This relies on how you run your builds (build vs build-us commands)
  return process.env.NEXT_PUBLIC_REGION === "US";
};

// Declare global window type augmentation
declare global {
  interface Window {
    __US_ENVIRONMENT?: boolean;
    dataLayer: any[];
  }
}
